export default class WritingAssistantProvider {
  type = 'writingAssistant' as const;

  onOpenWritingAssistant: () => void;

  constructor({
    onOpenWritingAssistant,
  }: {
    onOpenWritingAssistant: () => void;
  }) {
    this.onOpenWritingAssistant = onOpenWritingAssistant;
  }

  openWritingAssistant() {
    this.onOpenWritingAssistant();
  }
}
